/* src/app/home/location-list/location-list.component.scss */
@media (max-width: 739px) {
  .location-search {
    overflow: clip;
    height: max-content;
    position: sticky;
    top: 51px;
    background-color: white;
    z-index: 50;
    padding-bottom: 20px;
  }
}
.location-list {
  background: #FFF;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.location-list .location-items {
  overflow-x: hidden !important;
  height: 100%;
  width: 337px;
}
.location-list .input-group-text {
  width: 320px;
}
.search.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e668" !important;
  color: #FFF;
}
.clear.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e67b" !important;
  color: #FFF;
}
:host ::ng-deep location-search-input {
  width: calc(100% - 42px);
}
:host ::ng-deep input {
  width: 100%;
}
:host ::ng-deep .scrollable-content {
  padding-top: 1px;
}
:host ::ng-deep .selected .location {
  background-color: #FFD102;
}
.load-more-btn {
  display: block;
  border: 1px solid #00857D;
  border-radius: 100px;
  background: #FFF;
  margin: auto auto;
  margin-top: 1em;
  padding: 0.6em;
  padding-left: 6em;
  padding-right: 6em;
  color: #00857D;
}
.load-more-btn:focus {
  outline: none !important;
}
.sort-locations {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 320px;
}
.sort-locations ::ng-deep select {
  width: 272px;
}
.up-and-down-sort {
  box-shadow: none;
  background-color: white;
  border: thin #757575 solid;
  height: fit-content;
}
.up-and-down-sort:before {
  font-family: upsicons, fantasy !important;
  content: "\e619" !important;
}
@media screen and (max-width: 767px) {
  .sort-locations {
    width: 100%;
  }
  .sort-locations :host ::ng-deep select {
    width: 206px;
  }
}
@media (min-width: 1280px) {
  .location-list .location-items {
    width: 363px;
  }
  .location-list .input-group-text {
    width: 346px;
  }
  .sort-locations {
    width: 346px;
  }
  .sort-locations ::ng-deep select {
    width: 298px;
  }
  .location-items {
    width: auto;
  }
}
@media (min-width: 1880px) {
  .location-list .location-items {
    width: 377px;
  }
  .location-list .input-group-text {
    width: auto;
  }
  .sort-locations {
    width: auto;
  }
  .sort-locations ::ng-deep select {
    width: 319px;
  }
  .location-items {
    width: auto;
  }
}
/*# sourceMappingURL=location-list.component.css.map */
